import {
  Button,
  Col,
  Dropdown,
  MenuProps,
  Row,
  Space,
  Table,
  Tooltip,
} from 'antd';
import { ColumnsType } from 'antd/lib/table';
import styled from 'styled-components';
import { roleNameKoreanEnum, User } from '../../modules/auth';
import { defineAbilityFor } from '../../util/appAbilityService';
import { phoneFormatter } from '../../util/utils';
import { styledTable } from '../styled/mixin';
import { getInvitationUrl } from '../../api/constlink';
import { QuestionCircleOutlined } from '@ant-design/icons';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface MyEnterpriseUserListComponentProps {
  data: User[] | null;
  user: User;
  openUpdateUserRoleModal: (member: User) => void;
  openInviteMemberModal: () => void;
  deleteMemberAccount: (memberId: number) => void;
}

function MyEnterpriseUserListComponent({
  data,
  user,
  openUpdateUserRoleModal,
  openInviteMemberModal,
  deleteMemberAccount,
}: MyEnterpriseUserListComponentProps) {
  const ability = defineAbilityFor(user);

  const columns: ColumnsType<User> = [
    {
      title: '이름',
      dataIndex: 'name',
    },
    {
      title: '직급',
      dataIndex: 'workPosition',
    },
    {
      title: '이메일',
      dataIndex: 'email',
    },
    {
      title: '연락처(회사)',
      dataIndex: 'workPhone',
      render: (text: any, record: any) => <>{phoneFormatter(text, 1)}</>,
    },
    {
      title: '연락처(개인)',
      dataIndex: 'personalPhone',
      render: (text: any, record: any) => <>{phoneFormatter(text, 1)}</>,
    },
    {
      // title: '권한',
      title: (
        <Tooltip
          title={
            <p>
              관리자: 회사의 모든메뉴 접근가능
              <br />
              현장소장: 프로젝트의 모든메뉴 접근가능
              <br />
              현장기사: 프로젝트의 일부메뉴 접근가능
            </p>
          }
        >
          <span>
            권한 <QuestionCircleOutlined rev={undefined} />
          </span>
        </Tooltip>
      ),
      dataIndex: 'roleName',
      render: (value: any, record: User, index: number) =>
        roleNameKoreanEnum[value],
    },
    {
      title: '접근허용',
      dataIndex: 'isEnabled',
      render: (value: any, record: User, index: number) =>
        value ? '예' : '아니오',
    },
    {
      title: '',
      key: 'action',
      align: 'center',
      render: (text, record, index) => (
        <Space size="small">
          {ability.can('update', 'EnterpriseRole') && (
            <Button
              size="small"
              className="edit-table-list-item"
              onClick={(e) => {
                e.stopPropagation();
                openUpdateUserRoleModal(record);
              }}
            >
              수정
            </Button>
          )}
          {/* {ability.can('update', 'EnterpriseRole') && !!deleteMemberAccount && (
            <Popconfirm
              title="정말 멤버를 삭제 하시겠습니까?"
              onConfirm={() => {
                deleteMemberAccount(record.id);
              }}
            >
              <Button size="small">삭제</Button>
            </Popconfirm>
          )} */}
        </Space>
      ),
    },
  ];

  const handleCopyClipBoard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      alert('클립보드에 링크가 복사되었어요.');
    } catch (err) {
      console.log(err);
    }
  };

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: '메일로 초대하기',
    },
    {
      key: '2',
      label: '초대링크 복사하기',
    },
  ];

  const handleMenuClick: MenuProps['onClick'] = async (e) => {
    if (e.key === '1') openInviteMemberModal();
    else if (e.key === '2') {
      const res: any = await getInvitationUrl();
      handleCopyClipBoard(res.url);
    }
  };

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <h3>직원관리</h3>
        </Col>
        <Col>
          <Dropdown.Button
            menu={{ items, onClick: handleMenuClick }}
            placement="bottom"
            arrow
            size="small"
            style={{ marginRight: '70px' }}
          >
            더보기
          </Dropdown.Button>
        </Col>
      </Row>
      {data && (
        <Table<User>
          rowKey="id"
          columns={columns}
          dataSource={data}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
          // onRow={(record, rowIndex) => {
          //   return {
          //     onClick: (event) => {
          //       moveToUserDetailPage(record.id);
          //     },
          //   };
          // }}
        />
      )}
    </StyledDiv>
  );
}

export default MyEnterpriseUserListComponent;
